class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Close drawer on Escape
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    // Close drawer when clicking overlay
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    this.attachCartIcons();
  }

  attachCartIcons() {
    const icons = document.querySelectorAll('#cart-icon-bubble, .cart-icon-bubble');

    icons.forEach((icon) => {
      if (icon.dataset.drawerBound) return; // avoid double binding
      icon.dataset.drawerBound = true;

      icon.setAttribute('role', 'button');
      icon.setAttribute('aria-haspopup', 'dialog');

      icon.addEventListener('click', (event) => {
        const path = window.location.pathname.replace(/\/$/, '');
        if (path === '/cart') return; // redirect handled by Shopify

        event.preventDefault();
        this.open(icon);
      });

      icon.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(icon);
        }
      });
    });

    // Keep all bubbles in sync with original Shopify bubble
    const originalBubble = document.querySelector('#cart-icon-bubble');
    if (originalBubble) {
      const observer = new MutationObserver(() => {
        icons.forEach((icon) => {
          if (icon === originalBubble) return;
          icon.innerHTML = originalBubble.innerHTML;
        });
      });
      observer.observe(originalBubble, { childList: true, subtree: true });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.remove('overflow-hidden');
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling?.id) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', () => {
      cartDrawerNote.setAttribute(
        'aria-expanded',
        !cartDrawerNote.closest('details')?.hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner?.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'cart-icon-bubble') {
        const icons = document.querySelectorAll('#cart-icon-bubble, .cart-icon-bubble');
        icons.forEach((icon) => {
          icon.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            '.shopify-section'
          );
        });
        return;
      }

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
      .innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      if (section.id === 'cart-icon-bubble') {
        const icons = document.querySelectorAll('#cart-icon-bubble, .cart-icon-bubble');
        icons.forEach((icon) => {
          icon.innerHTML = new DOMParser()
            .parseFromString(parsedState.sections[section.section], 'text/html')
            .querySelector(section.selector).innerHTML;
        });
        return;
      }

      const sectionElement = document.querySelector(section.selector);
      if (!sectionElement) return;

      sectionElement.innerHTML = new DOMParser()
        .parseFromString(parsedState.sections[section.section], 'text/html')
        .querySelector(section.selector).innerHTML;
    });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);